<div class="minicart-wrapper" *ngIf="checkout">
  <div class="minicart d-flex flex-column">
    <div class="contents">
      <div class="d-flex flex-row justify-content-between">
        <h4 class="mb-0 text-black">Your Cart</h4>
        <img (click)="close()" height="24" width="24" src="/assets/close.svg" />
      </div>
    </div>
    <div
      class="items"
      *ngIf="
        checkout?.state === 'loading' &&
        !checkout?.lines &&
        !checkout?.lines?.edges
      "
    >
      <div
        class="d-flex justify-content-center align-items-center flex-column h-100"
      >
        <div class="display-1 border-bottom pb-4 mb-4">Loading Cart!</div>
        <p>Please wait</p>
      </div>
    </div>

    <div
      class="d-flex justify-content-center align-items-center flex-column h-100"
      *ngIf="
        checkout?.state === 'noitems' ||
        (checkout?.lines &&
          checkout?.lines?.edges !== undefined &&
          checkout.lines.edges.length == 0)
      "
    >
      <div class="display-1 border-bottom pb-4 mb-4">Go Shopping!</div>
      <p>No items in cart</p>
    </div>

    <ng-container
      *ngIf="checkout?.lines?.edges && checkout?.lines?.edges.length > 0"
    >
      <app-motivator
        [totalQty]="_totalQty"
        [theme]="theme"
        *ngIf="_upsell?.length == 0 && _totalQty < 4"
        [cart]="checkout"
      >
      </app-motivator>
      <div class="items">
        <app-conditional-upsell
          *ngIf="_upsell.length > 0"
          [theme]="theme"
          [_upsell]="_upsell"
          [cart]="checkout"
        >
        </app-conditional-upsell>
        <app-lineitem
          class="d-flex"
          [lineItem]="item.node"
          [ngClass]="{ 'mb-4 pb-4 border-bottom': !last, disable: _processing }"
          *ngFor="let item of checkout?.lines?.edges; let last = last"
        ></app-lineitem>
      </div>
    </ng-container>
    <div class="actions" *ngIf="checkout?.lines?.edges?.length">
      <app-shipping-toggle
        *ngIf="theme?.content?.toggle_product"
        [handle]="theme.content.toggle_product"
      ></app-shipping-toggle>
      <a class="btn btn-primary w-100 mb-2" [href]="checkout.checkoutUrl"
        >Checkout - {{ checkout?.cost?.subtotalAmount?.amount | currency }}</a
      >
      <a
        (click)="close()"
        [routerLink]="['/ndis-checkout']"
        class="btn btn-outline-primary w-100"
        >Invoice for NDIS</a
      >
    </div>
  </div>
</div>
<div class="bg" (click)="clickedOutside($event)"></div>
